export class Validators {
    static isValidFile(files, types) {
        const typesFiles = {
            "application/pdf": ".pdf",
            "application/vnd.ms-excel": ".xlsx",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
                ".xlsx",
            "application/zip": ".zip",
            "application/x-zip-compressed": ".zip"
        };

        return !!files.find((f) => types.includes(typesFiles[f.type]));
    }

    static async isValidByTypeFile(files, type) {
        const typesFile = {
            eSocial: (file) => {
                if (file?.content) {
                    if (file.content.includes("eSocial")) return true;
                    return false;
                }
            },
            pgdas: (file) => {}
        };

        let response = [];
        for (let file of files) {
            if (typesFile[type]) {
                response.push(typesFile[type](file));
            }
        }

        if (response.includes(false)) return false;
        return true;
    }
}
